import { render } from "./Account.vue?vue&type=template&id=31b57c5b&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import "./Account.vue?vue&type=style&index=0&id=31b57c5b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-31b57c5b"

export default script